<template lang="pug">
#assemApp.bg-blue-200(@click='bigImgClicked')
  div(style="margin:10px 10px;display:inline-block;width:100%;")
    div(v-show="editMode"
        style="width:100%; display:inline-block;")
      div(style='display:inline-block;width:33%')
        button(@click='addPart')  Add
        button(@click='editPart') Edit
        button(@click='delPart')  Delete
        button(@click='partBack') Back
        button(@click='nextNote') Next-Note
        //- button(@click='printClick' 
        //-         style="float:right;margin-right:30px") Printed
      div(style='display:inline-block;width:33%')
        button(@click='addSub')   Add
        button(@click='editSub')  Edit
        button(@click='delSub')   Delete
        button(@click='nextSub')  Next-Sub
        button(@click='addOrder' 
                style="float:right;margin-right:20px") Add Order
      div(style=`font-weight:bold; margin-left:20px;
                  display:inline-block`) P4 Assembly Guide

  #left.column
    .line(ref='thisEle' v-for='part in parts' :key='part.partNo' 
         :class="{haveSel:  part.state === 'haveSel',\
        have:     part.state === 'have',\
        canSel:   part.state === 'canSel',\
        can:      part.state === 'can',\
        shortSel: part.state === 'shortSel',\
        short:    part.state === 'short'}" @click='lineClicked(part.partNo)' @dblclick='lineDblClicked(part.partNo)')
      span.partNo {{part.partNo}}: 
      |  {{part.descr}} 
      span(v-show='editMode')
        span(v-show='part.bomQty > 1')
          | ({{part.bomQty}})
        span(v-if='sortByCost && part.cost && part.bomQty' 
             v-bind:class='{bold: part.cost * part.bomQty >= 2}')
          | ${{(part.bomQty * part.cost).toFixed(2)}}
        span(v-if='part.cost && !part.bomQty')
          | ${{part.cost.toFixed(2)}}
        span(v-if='part.printed') 
          | *

    part-editor(
      v-if='showPartEditor' 
      v-bind:new-part='newPart' 
      v-bind:last-part-no='lastPartNo' 
      v-bind:parts='parts' 
      v-bind:show-part-editor='showPartEditor' 
      v-bind:sel-part-no='selPartNo')
  
  #middle.column
    #subCol
      div
        .col-hdr(v-if='selPartNo && subs && subs.length')
          | Parts for {{part(selPartNo).partNo}} {{part(selPartNo).descr}}
        .subLine(v-for='(sub, idx) in subs' :key='sub.idx' :class="{ haveSel:  sub.state === 'haveSel',\
        have:     sub.state === 'have',\
        canSel:   sub.state === 'canSel',\
        can:      sub.state === 'can',\
        shortSel: sub.state === 'shortSel',\
        short:    sub.state === 'short'}" 
            @click='subClicked(idx)' 
            @dblclick='subDblClicked(idx)')
          span(v-show='sub.label') {{sub.label}}) 
          span.partNo {{sub.partNo}}:
          |             {{sub.descr}}
          span(v-show='sub.qty > 1') ({{sub.qty}})
          span.bolt(v-show='sub.bolt !== undefined')  [{{sub.bolt}}]
          span.washer(v-show='sub.washer !== undefined')  -W
          span(v-if='part(selPartNo).printed')  *
        div(v-show='showAssemBtn()' style='margin-top:10px;')
          button(@click='assembled')
            | Assembled
        div(v-show='showUndoAssemBtn()' style='margin-top:10px;')
          button(@click='undoAssem')
            | Undo Assembly

      TextareaAutosize.bg-gray-300.mt-4.min-w-full(
        @input="noteChanged"
        placeholder="Notes..." v-model="curPart.notes" :min-height="30")

      div(v-show='selPartNo && editMode')
        #inv-hdr.col-hdr
          | Inventory for Part {{selPartNo}}
        #inv-form
          .inv-input
            | Qty: 
            input(v-on:keyup.enter='setInvQty' size='5' v-model='invQtyVal')
            br
          .inv-input
            | Add: 
            input(v-on:keyup.enter='invAdd' size='3' v-model='invAddVal')
            br
          .inv-input
            | Rem: 
            input(v-on:keyup.enter='invRem' size='3' v-model='invRemVal')
        div(v-show='partOrders !== null && partOrders.length')
          #orders-hdr.col-hdr
            | Orders for Part {{selPartNo}}
          div
            order-card.order-card(
              v-for='order in partOrders' :key='order.orderNo' 
              v-bind:part='curPart' 
              v-bind:order='order')
      div
        sub-editor( v-if='showSubPartEditor' 
          v-bind:new-sub-part='newSubPart' 
          v-bind:subs='subs' 
          v-bind:sel-sub-idx='selSubIdx')
      div
        order-editor( v-if='showOrderEditor' 
          v-bind:sel-part-no='selPartNo' 
          v-bind:part='curPart' 
          v-bind:new-order='newOrder' 
          v-bind:orders='orders' 
          v-bind:order-no='orderNo')

  #right.column
    div(:class="{'small-div':  !useSmallImg(img),\
    'smaller-div': useSmallImg(img)}" v-for='(img, idx) in imgs' :key='img.src')
      span.label(v-show='idx===0 || idx===imgs.length-1')
        | {{img.partNo}}
      br
      img(:class="{'small-img':  !useSmallImg(img),\
        'smaller-img': useSmallImg(img)}" 
           @click='smallImgClicked(img.src,$event)' 
           :src='img.src + "?" + Math.random()')
    div(v-show='showBigImage')
      img.big-img(:src='bigImgSrc')
</template>

<script>
import axios        from 'axios';
import partEditor   from './part-editor';
import subEditor    from './sub-editor';
import orderEditor  from './order-editor';
import orderCard    from './order-card';

export default {
  name: 'p4-assem',
  components: {partEditor, subEditor, orderEditor, orderCard},

  data () {
    return {
      parts: null,
      // assemParts: [],
      // leafParts: [],
      selPartNo: '',
      curPart: {notes:null},
      selPartNoHistory: [],
      lastPartNo: '',
      newPart: false,
      showPartEditor: false,

      invQtyVal: 0,
      invAddVal: '',
      invRemVal: '',
      unitsNeeded: 1,

      subs: null,
      selSubIdx: null,
      newSubPart: false,
      showSubPartEditor: false,

      orders: [],
      partOrders: null,
      newOrder: false,
      showOrderEditor: false,
      orderNo: null,

      imgs: [],
      showBigImage: false,
      bigImgSrc: '',
      smallerImg: false,

      db:       null,
      dbclient: null,
      dbuser:   null,

      editMode: true,
      sortByCost: false,
    }
  },
  methods: {
    calcBomAndCost() {
      const calcOnePart = (partNo, qty) => {
        const part = this.part(partNo);
        if(!part) {
          console.log('No part for partNo:', partNo);
          return 0;
        }
        if(!part.bomQty) part.bomQty = 0;
        part.bomQty += qty;
        if(part.subs && part.subs.length) {
          if(part.qty) throw "Assem has qty: " + partNo;
          let cost = 0;
          part.cost = 0;
          for(let sub of part.subs) {
            if(!sub.qty) throw 'No qty for sub: ' + sub.partNo;
            const partCost = calcOnePart(sub.partNo, qty * sub.qty);
            part.cost += partCost * sub.qty;
            cost += partCost;
          }
        }
        else {
          if(part.qty) throw "leaf part has qty: " + partNo + ', ' + part.qty;
          part.cost = this.getCost(partNo);
        }
        return part.cost;
      }
      calcOnePart('A00P4', 1);
    },
    getCost (leafPartNo) {
      let minCost = 1e6;
      for(let order of this.orders) {
        for(let orderPartNo of order.parts) {
          if(orderPartNo === leafPartNo) {
            let costPerPart;
            if(order.amountPaid)
              costPerPart = order.amountPaid / order.partsPerPack;
            else
              costPerPart = (order.packCount * order.costPerPack) / 
                             order.partsPerPack;
            minCost = Math.min(minCost, costPerPart);
          }
        }
      }
      if(minCost === 1e6) {
        console.log("no order for:", leafPartNo);
        minCost = 0;
      }
      return minCost;
    },
    sortParts () {
      if(this.sortByCost) 
        this.parts.sort( 
            (a,b) => ((b.cost && b.bomQty ? b.cost * b.bomQty : 0) - 
                      (a.cost && a.bomQty ? a.cost * a.bomQty : 0)));
      else this.parts.sort( (a,b) => a.seq - b.seq );
      if(this.selPartNo) {
        setTimeout( () => {
          this.$refs.thisEle[this.partIdx(this.selPartNo)]
                    .scrollIntoView({block:"center"});
        }, 100);
      }
    },
    sortSubs () {
      if(this.subs) {
        if(!this.selSubIdx) {
          this.selSubIdx = 0;
        }
        this.subs.sort( (a,b) => a.partNo > b.partNo ? +1 : -1);
        this.subs.forEach( (sub, idx) => {
          const subPart = this.part(sub.partNo);
          if(subPart) sub.descr = subPart.descr;
          if(!sub.descr) sub.descr = '<part not found>';
        });
      }
    },
    sortOrders () {
      this.orders.sort( (a,b) => b.orderNo - a.orderNo);
      this.partOrders = [];
      this.orders.forEach( (order) => {
        order.parts.forEach( (partNo) => {
          if(partNo === this.selPartNo)
           this.partOrders.push(order);
        });
      });
    },
    startSubs() {
      this.subs = [];
      this.part(this.selPartNo).subs = this.subs;
      this.selSubIdx = null;
    },
    newSeq (idx, dir) {
      const neighbor1 = this.parts[idx];
      const neighbor2 = this.parts[idx + dir];
      let newSeq;
      if(neighbor1 && neighbor2) {
        newSeq = (neighbor1.seq + neighbor2.seq) / 2;
      }
      else {
        if(dir === -1) newSeq = this.parts[0].seq - 1;
        else           newSeq = this.parts[this.parts.length-1].seq + 1;
      }
      return newSeq;
    },
    setState: function (part, partSet, sel) {
      // console.log({part, partSet, sel});
      if(!partSet) partSet = part;
      if(!sel) sel = (part.partNo === this.selPartNo);
      if(part.inv && part.inv >= part.bomQty) {
        if(sel) partSet.state = 'haveSel';
        else    partSet.state = 'have';
      }
      else if(this.haveSubInv(part.partNo)) {
        if(sel) partSet.state = 'canSel';
        else    partSet.state = 'can';
      }
      else {
        if(sel) partSet.state = 'shortSel';
        else    partSet.state = 'short';
      }
      
    },
    setSubStates: function () {
      if(this.subs) {
        for(let sub of this.subs) {
          this.setState(this.part(sub.partNo), 
                        sub, (sub.idx === this.selSubIdx))
        }
      }
    },
    assembled (sub) {
      this.curPart.inv++;
      this.setState(this.curPart);
      for(let sub of this.curPart.subs){
        const subPart = this.part(sub.partNo);
        subPart.inv -= sub.qty;
        this.setState(subPart);
        this.dbUpdatePart(subPart);
      }
      this.dbUpdatePart(this.curPart);
      this.sortParts();
      this.setSubStates();
      this.setInvQtyVal();
    },
    undoAssem (sub) {
      this.curPart.inv--;
      this.setState(this.curPart);
      for(let sub of this.curPart.subs){
        const subPart = this.part(sub.partNo);
        subPart.inv += sub.qty;
        this.setState(subPart);
        this.dbUpdatePart(subPart);
      }
      this.dbUpdatePart(this.curPart);
      this.sortParts();
      this.setSubStates();
      this.setInvQtyVal();
    },
    showAssemBtn () {
      return (this.selPartNo && 
              this.part(this.selPartNo).state === 'canSel');
    },
    showUndoAssemBtn () {
      if(!this.selPartNo) return;
      const idx = this.partIdx(this.selPartNo);
      if(!this.isAssem(idx)) return;
      const part = this.parts[idx];
      if(!part) return;
      return (part.inv > 0);
    },
    lineClicked (partNo, nopush = false) {
      let lastPart = null;
      if(this.lastPartNo) lastPart = this.part(this.lastPartNo);
      const part = this.part(partNo);
      if(!part) return;
      if(!nopush)
        this.selPartNoHistory.push(partNo);
      const annotateCount = part.annotateCount;
      this.setImg(null, 'imgTop');
      this.setImg(null, 'imgBot');
      this.selPartNo  = partNo;
      this.lastPartNo = partNo;
      this.curPart = this.part(partNo);
      if(this.curPart) {
        this.subs = this.curPart.subs;
        this.sortSubs();
        this.selSubIdx = null;
        this.invQtyVal = this.curPart.inv;
        this.invAddVal = '';
        this.invRemVal = '';
        this.setImg (partNo, 'imgTop', annotateCount);
        this.setState(this.curPart);
      }
      else this.subs = [];
      this.sortOrders();
      if(lastPart) this.setState(lastPart);
      this.setSubStates();
    },

    lineDblClicked (partNo) {
loop: for (let part of this.parts) {
        if(part.subs) {
          for (const [idx, sub] of part.subs.entries()) {
            if(sub.partNo === partNo) {
              this.lineClicked(part.partNo);
              this.sortParts();
              this.subClicked(idx);
              break loop;
            }
          }
        }
      }
    },
    subClicked (idx) {
      this.setImg(null, 'imgBot');
      this.selSubIdx = idx;
      const sub = this.subs[idx];
      if(sub) this.setImg(sub.partNo, 'imgBot');
      this.setSubStates();
      this.sortSubs();
    },
    subDblClicked (idx) {
      this.lineClicked(this.subs[idx].partNo);
      this.sortParts();
    },
    
    smallImgClicked (src, event) {
      if(!this.showBigImage) {
        event.preventDefault();
        event.stopPropagation();
        this.showBigImage = true;
        this.bigImgSrc = src;
      }
    },
    bigImgClicked () {
      if(this.showBigImage) {
        this.showBigImage = false;
        this.bigImgSrc = '';
      }
    },

    partIdx (partNo) {
      for(let i=0; i < this.parts.length; i++)
        if(this.parts[i].partNo === partNo) return i;
    },

    part (partNo) {
      return this.parts[this.partIdx(partNo)];
    },

    moveUpDn (shiftKey, dir) {
      event.stopPropagation();
      const thisIdx = this.partIdx(this.selPartNo);
      if(thisIdx === undefined        ||
        (dir === -1 && thisIdx === 0) ||
        (dir === +1 && thisIdx === (this.parts.length-1)))
          return;
      const idx = thisIdx + (dir * (shiftKey ? 10 : 1));
      this.parts[thisIdx].seq = this.newSeq(idx, dir);
      this.sortParts();
    },

    keypress (event) {
      if(event.ctrlKey && event.shiftKey) {
        switch (event.key) {
          case 'E':
            event.preventDefault();
            event.stopPropagation();
            this.editMode = !this.editMode;
            break;
          case 'S':
            event.preventDefault();
            event.stopPropagation();
            this.sortByCost = !this.sortByCost;
            this.sortParts();
            break;
        }
      }
    },
    addPart () {
      if(this.selPartNo)
          this.lastPartNo = this.part(this.selPartNo).partNo;
      this.newPart = true;
      this.showPartEditor    = true;
      this.showSubPartEditor = false;
      this.showOrderEditor   = false;
    },
    editPart () {
      this.newPart = false;
      this.showSubPartEditor = false;
      this.showPartEditor = true;
    },
    delPart () {
      if(this.selPartNo && 
         window.confirm('Do you really want to delete part ' + this.selPartNo)){
        const idx = this.partIdx(this.selPartNo);
        if(idx !== undefined) {
          this.parts.splice(idx,1);
          this.dbDelPart(this.selPartNo);
          this.sortParts();
          this.selPartNo = this.parts[0].partNo;
        }
      }
    },
    addSub () {
      if(!this.selPartNo) return;
      if(!this.subs) this.startSubs();
      this.newSubPart = true;
      this.showPartEditor    = false;
      this.showSubPartEditor = true;
      this.showOrderEditor   = false;
    }, 
    editSub () {
      if(!this.selPartNo) return;
      this.newSubPart        = false;
      this.showPartEditor    = false;
      this.showSubPartEditor = true;
    },
    delSub () {
      const sub = this.subs[this.selSubIdx];
      if(sub && 
          window.confirm('Do you really want to delete part ' + sub.partNo)) {
        if(this.selSubIdx !== undefined) {
          this.subs.splice(this.selSubIdx,1);
          this.setImg(null, 'imgBot');
        }
        this.sortSubs();
        this.dbUpdatePart(this.curPart);
      }
    },
    noteChanged() {
      console.log('noteChanged', this.curPart);
      if(this.curPart) this.dbUpdatePart(this.curPart);
    },
    addOrder () {
      if(!this.selPartNo) return;
      this.orderNo           = null;
      this.newOrder          = true;
      this.showPartEditor    = false;
      this.showSubPartEditor = false;
      this.showOrderEditor   = true;
    },
    editOrder (orderNo) {
      this.orderNo           = orderNo;
      this.newOrder          = false;
      this.showPartEditor    = false;
      this.showSubPartEditor = false;
      this.showOrderEditor   = true;
    },
    partBack () {
      let lastPart = this.selPartNoHistory.pop();
      if(this.lastPartNo === lastPart)
        lastPart = this.selPartNoHistory.pop();
      this.lineClicked(lastPart, true);
      this.sortParts();
    },
    printClick () {
      this.curPart.printed = !this.curPart.printed;
      this.sortParts();
      this.dbUpdatePart(this.curPart);
    },
    nextNote () {
      if(!this.selPartNo) return;
      const oldPartIdx = this.partIdx(this.selPartNo);
      for(let partIdx = oldPartIdx+1;
              partIdx < this.parts.length; partIdx++) {
        if(this.parts[partIdx].notes) {
          this.lineClicked(this.parts[partIdx].partNo);
          this.sortParts();
          return;
        }
      }
      for(let partIdx = 0; partIdx < oldPartIdx; partIdx++) {
        if(this.parts[partIdx].notes) {
          this.lineClicked(this.parts[partIdx].partNo);
          this.sortParts();
          return;
        }
      }
    },
    nextSub () {
      if(this.selSubIdx !== null) {
        let foundPartNo = null;
        let foundSubIdx = 0;
        const chkSubs = (partIdx) => {
          const part = this.parts[partIdx];
          const subs = part.subs;
          if(subs) {
            for(let subIdx = 0; subIdx < subs.length; subIdx++) {
              if(subs[subIdx].partNo === subPartNo) {
                foundPartNo = part.partNo;
                foundSubIdx = subIdx;
                return true;
              }
            }
          }
        }
        const subPartNo     = this.subs[this.selSubIdx].partNo;
        const oldSelPartIdx = this.partIdx(this.selPartNo);
        const oldSelSubIdx  = this.selSubIdx;
        for(let partIdx = oldSelPartIdx+1; 
                partIdx < this.parts.length; partIdx++) {
          if(chkSubs(partIdx)) break;
        }
        if(!foundPartNo) {
          for(let partIdx = 0; partIdx < oldSelPartIdx; partIdx++) {
            if(chkSubs(partIdx)) break;
          }
        }
        if(foundPartNo && foundPartNo !== this.selPartNo) {
          this.lineClicked(foundPartNo);
          this.sortParts();
          this.subClicked(foundSubIdx);
          this.sortSubs();
        }
      }
    },
    setInvQtyVal () {
      this.invQtyVal = this.curPart.inv;
    },
    setInvQty () {
      this.curPart.inv = +this.invQtyVal;
      this.dbUpdatePart(this.curPart);
      // document.getElementsByClassName("inv-input")[0].blur();
    },
    invAdd () {
      this.curPart.inv += +this.invAddVal;
      this.invQtyVal = this.curPart.inv;
      this.invAddVal = '';
      this.dbUpdatePart(this.curPart);
      // document.getElementsByClassName("inv-input")[1].blur();
    },
    invRem () {
      this.curPart.inv -= +this.invRemVal;
      this.invQtyVal = this.curPart.inv;
      this.invRemVal = '';
      this.dbUpdatePart(this.curPart);
      // document.getElementsByClassName("inv-input")[2].blur();
    },
    haveSubInv (partNo) {
      const part = this.part(partNo);
      if(!part) return false;
      if(part.subs && part.subs.length > 1) {
        for(let sub of part.subs) {
          const subPart = this.part(sub.partNo);
          if(!subPart) return false;
          if(subPart.inv < subPart.bomQty ||!this.haveSubInv(sub.partNo)) 
            return false;
        }
        return true;
      }
      else {
        if(part.bomQty && (!part.inv || part.inv < part.bomQty)) return false;
        else return true;
      }
    },
    setImg (partNo, id, annotateCount) {
      if(partNo === null) {
        for(let i=0; i < this.imgs.length; i++) {
          const img = this.imgs[i];
          if(img.id === id) {
            delete this.imgs.splice(i,1);
            i--;
          }
        }
        return;
      }
      if(id === 'imgTop' && annotateCount) {
        for(let i=annotateCount; i>0; i--) {
          const entry = {partNo, src:`/part-images/${partNo}@${i}.png?${Math.random()}`, id};
          if(id === 'imgTop') this.imgs.unshift(entry);
          else                this.imgs.push(entry);
        }
      } else {
        const entry = 
            {partNo, src:`/part-images/${partNo}.png?${Math.random()}`, id};
        if(id === 'imgTop') this.imgs.unshift(entry);
        else                this.imgs.push(entry);
      }
    },
    useSmallImg (img) {
      const part = this.part(this.selPartNo);
      return (img.id !== 'imgBot' && this.imgs.length > 2 &&
              part.annotateCount  && part.annotateCount > 1);
    },
    async initdb () {
      try {
        this.dbclient = stitch.Stitch
              .initializeDefaultAppClient('p4assem-srrfh');
        const apiKeyClient = this.dbclient.auth
             .getProviderClient(stitch.UserApiKeyAuthProviderClient.factory);
        const apiKey = 'HpXEvKAhXz8iB9Dq1LBXHMpcrli1Qujyvz6bkhkJgO806FWKIQtaM9P12x0lm9EG';
        const credential = new stitch.UserApiKeyCredential(apiKey);
        const authedId = 
            await this.dbclient.auth.loginWithCredential(credential);
        this.db = await this.dbclient.getServiceClient(
            stitch.RemoteMongoClient.factory, 'mongodb-atlas')
          .db('p4assem');
      }
      catch(err) {
        console.error('initdb:', err);
      }
    },
    async dbNewOrderNo () {
      return (await this.db.collection('counters')
                    .findOneAndUpdate(
                      {_id: 'lastOrderNoId'}, 
                      {$inc: {orderNo:1}},
                      {returnOriginal:false})
              ).orderNo;
    },
    async dbAddPart (part) {
      if(Array.isArray(part))
           await this.db.collection('parts').insertMany(part);
      else await this.db.collection('parts').insertOne(part);
    },
    async dbAddOrder (order) {
      if(Array.isArray(order))
           await this.db.collection('orders').insertMany(order);
      else await this.db.collection('orders').insertOne(order);
    },
    async dbUpdatePart (part) {
      await this.db.collection('parts')
          .updateOne({partNo: part.partNo}, {$set: part});
    },
    async dbUpdateOrder (order) {
      await this.db.collection('orders')
          .updateOne({orderNo: order.orderNo}, {$set: order});
    },
    async dbDelPart (partNo) {
      await this.db.collection('parts').deleteOne({partNo});
    },
    async dbDelOrder (orderNo) {
      await this.db.collection('orders').deleteOne({orderNo});
    },
    isAssem: function (idx) {
      return this.parts[idx].subs && this.parts[idx].subs.length > 1;
    },
  },

  watch: {
    selPartNo: (spn) => {
      localStorage.setItem('selPartNo', spn);
    }
  },

  created: async function() {
    await this.initdb();
    document.addEventListener('keydown', this.keypress);

    let parts = await this.db.collection('parts').find({}).toArray();
    parts.sort( (a,b) => {
      // if(a.subs && a.subs.length > 1 && (!b.subs || b.subs.length < 2)) return -1;
      // if(b.subs && b.subs.length > 1 && (!a.subs || a.subs.length < 2)) return +1;
      const al = a.partNo[0];
      const bl = b.partNo[0];
      if(al !== bl) return ((al > bl) ? +1 : -1);
      const matchA = /^.*?(\d+).*$/.exec(a.partNo);
      const matchB = /^.*?(\d+).*$/.exec(b.partNo);
      const aa = ((matchA) ? +matchA[1] : 0);
      const bb = ((matchB) ? +matchB[1] : 0);
      if(aa === bb) return ((a.partNo > b.partNo) ? +1 : -1);
      return aa-bb;
    });
    this.parts = parts;
    // this.assemParts = parts.filter( (part, idx) =>  this.isAssem(idx) );
    // this.leafParts  = parts.filter( (part, idx) => !this.isAssem(idx) );

    let orders = await this.db.collection('orders').find({}).toArray();
    this.orders = orders;

    for(let [idx, part] of parts.entries()) {
      part.seq = idx;
      part.bomQty = 0;
      if(part.subs) {
        let w2Count = 0;
        let w3Count = 0;
        let w2Sub = null;
        let w3Sub = null;
        for(let idx=0; idx < part.subs.length; idx++) {
          const sub = part.subs[idx];
          if(sub.washer) {
            if(     sub.partNo.slice(0,2) === 'M3') w3Count += sub.qty;
            else if(sub.partNo.slice(0,2) === 'M2') w2Count += sub.qty;
          }
          if(sub.partNo === 'W3' || sub.partNo.slice(0,2) === 'W2') {
            part.subs.splice(idx,1);
            idx--;
          }
        }
        if(w2Count) {
          if(w2Sub === null) {
            w2Sub = {partNo: 'W2.5'};
            part.subs.push(w2Sub);
          }
          w2Sub.qty = w2Count;
        }
        if(w3Count) {
          if(w3Sub === null) {
            w3Sub = { partNo: 'W3'};
            part.subs.push(w3Sub);
          }
          w3Sub.qty = w3Count;
        }
        for(let [idx, sub] of part.subs.entries()) {
          sub.idx = idx;
        }
      }
     this.setState(part);
    }
    for(let order of this.orders) {
      if(order.partUrl) {
        const vendorMatches = /([a-zA-Z]+)\.com/.exec(order.partUrl);
        if(vendorMatches) 
          order.vendor = vendorMatches[1];
      }
    }
    this.calcBomAndCost();
    this.sortParts();
    
    const spn = localStorage.getItem('selPartNo');
    console.log({spn});
    if(spn) {
      this.selPartNo = spn;
      console.log('lineClicked', {spn});
      this.lineClicked(spn);
      this.sortParts();
    }
  },
  mounted: function () {
    this.$watch('parts', () => {
      for(let part of this.parts)
        this.setState(part);
    },{deep:true});
  },
}
</script>

<style scoped>

#assemApp {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 16px;
}
.selected      {background-color:#ccc}
.invShort      {background-color:#edd}
.invShortSel   {background-color:#daa}

.haveSel  {background-color:#ccc}
.have     {background-color:white}
.canSel   {background-color:#aea}
.can      {background-color:#dfd}
.shortSel {background-color:#daa}
.short    {background-color:#edd}

#inv-hdr-lbl {
  font-weight: normal;
  font-size: 20px;
}
#inv-form{
  font-weight: bold;
  margin: 20px 20px;
}
.inv-input {
  display: inline-block;
  position:relative;
  top: -10px;
  margin-left: 20px;
}
.lbl {
  text-decoration: none;
  font-weight: bold;
  margin-right: 20px;
}
.column {
  border: 1px solid black;
  overflow-x:hidden;
  overflow-y:auto;
  width: 33%;
  height: 550px;
  float: left;
}
.col-hdr {
  font-weight:  bold;
  text-align: center;
  text-decoration: underline;
  width:100%;
}
#inv-hdr {
  margin-top: 15px;
}
#orders-hdr{
  margin-top: -10px;
}
.line {
  margin-left: 10px;
  margin-top: 7px;
}
.label{
  font-weight:  bold;
}
.partNo{
  font-weight:  bold;
}
.subLine {
  margin-left: 10px;
  margin-top: 7px;
}
button{
  margin-left: 10px;
}
#order-btns {
  position:relative;
  left:360px;
  display: inline-block;
}
#order-btns-label {
  position:relative;
  left:270px;
  display: inline-block;
  font-weight: bold;
}
.small-div {
  display: inline-block;
}
.smaller-div {
  display: inline-block;
  max-width: 42%;
}
.small-img {
  width:100%;
}
.smaller-img {
  margin-left: 10px;
  width:100%
}
.big-img {
  max-width:100%;
  max-height:100%; 
  z-index:2;
  position: fixed;
  left:0;
  top:0%;
}
.bold {
  font-weight: bold;
}
</style>